import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../app/AuthContext";

interface Row {
  id: string;
  slug: string;
  name: string;
  canonical_domain: string | null;
  country: string | null;
  status: string;
  published_at: string | null;
  created_at: string;
}

export function AdminBrandsPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const status = params.get("status") ?? "";
  const q = params.get("q") ?? "";
  const [items, setItems] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.admin.brandsList({ status: status || undefined, q: q || undefined })
      .then((r) => setItems(r.items))
      .finally(() => setLoading(false));
  }, [status, q]);

  if (!user || (user.role !== "admin" && user.role !== "super_admin")) {
    return <div className="container empty-state">Admin access required.</div>;
  }

  return (
    <div className="container" style={{ paddingBlock: "2rem" }}>
      <div className="section__head">
        <h2>Brands ({items.length})</h2>
        <Link to="/admin/brands/new"><button className="primary">+ Add brand</button></Link>
      </div>

      <div className="filter-bar">
        <select value={status} onChange={(e) => setParams((p) => { p.set("status", e.target.value); return p; })}>
          <option value="">All statuses</option>
          <option value="candidate">candidate</option>
          <option value="review">review</option>
          <option value="published">published</option>
          <option value="rejected">rejected</option>
          <option value="removed">removed</option>
        </select>
        <input
          type="search" placeholder="Search name or domain…" defaultValue={q}
          onKeyDown={(e) => { if (e.key === "Enter") setParams((p) => { p.set("q", (e.target as HTMLInputElement).value); return p; }); }}
          style={{ maxWidth: 280 }}
        />
      </div>

      {loading ? <div className="empty-state">Loading…</div> : (
        <div className="admin-table-wrap"><table className="admin-table">
          <thead>
            <tr><th>Name</th><th>Domain</th><th>Country</th><th>Status</th><th>Published</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id}>
                <td>{b.name}</td>
                <td>{b.canonical_domain ?? "—"}</td>
                <td>{b.country ?? "—"}</td>
                <td>{b.status}</td>
                <td>{b.published_at ? new Date(b.published_at).toLocaleDateString() : "—"}</td>
                <td><Link to={`/admin/brands/${b.id}`}>Edit →</Link></td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: "center", color: "var(--fg-subtle)", paddingBlock: "2rem" }}>No brands.</td></tr>
            )}
          </tbody>
        </table></div>
      )}
    </div>
  );
}
